export default __webpack_public_path__ + "static/media/universal_vault.8cee1253.svg";